var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#2F4858",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 12L23.5608 2.56137C24.1467 1.97541 24.1467 1.02538 23.5608 0.43947C22.9748 -0.14649 22.0248 -0.14649 21.4389 0.43947L12.0002 9.87905L2.56161 0.43947C1.97565 -0.14649 1.02563 -0.14649 0.439714 0.43947C-0.146199 1.02543 -0.146246 1.97545 0.439714 2.56137L9.8793 12L0.439714 21.4386C-0.146246 22.0246 -0.146246 22.9746 0.439714 23.5605C1.02567 24.1464 1.9757 24.1465 2.56161 23.5605L12.0002 14.1209L21.4388 23.5605C22.0248 24.1465 22.9748 24.1465 23.5607 23.5605C24.1467 22.9745 24.1467 22.0245 23.5607 21.4386L14.1211 12Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.2d3289d3b8c32464f292cafeeabae150.svg";
export { ForwardRef as ReactComponent };